import { render } from "./GridPage.vue?vue&type=template&id=43f9897a&ts=true"
import script from "./GridPage.vue?vue&type=script&lang=ts"
export * from "./GridPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__